import { useState } from "react";
import { useSelector } from "react-redux";
import { fetchDataNew as DynamicFetchNew, addData } from '../Redux/Slices/Transaction/DynamicSlice.js';

import Swal from "sweetalert2";
const getList = (id) => {

    let list = document?.getElementById('mytable')
    let card = document?.getElementById('myCard')
    list.style.display = 'none';
    card.style.display = 'none';

    if (id == 'list') {
        list.style.display = 'block';
    }
    else {
        card.style.display = 'block';
    }
}

export const AlertPopup = {
    errorPopup: (message) => {
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: message,
            showConfirmButton: false,
            timer: 1500,
            toast: true
        });
    },
    warningPopup: (message) => {
        Swal.fire({
            position: "center",
            icon: "warning",
            text: message,
            showConfirmButton: true,
            // timer: 1500,
            // toast: true
        });
    },
    errorPopupBig: (title, message) => {
        Swal.fire({
            position: "center",
            icon: "error",
            title: title,
            text: message,
            showConfirmButton: true,
            // timer: 1500,
            // toast: true
        });
    },
    SuccessPopup: (message) => {
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 1500,
            toast: true
        });
    }
}


export const ConfirmPopupBig = (title, message) => {
    return Swal.fire({
        title: title,
        text: message,
        icon: "warning",
        // showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        // showCancelButton: true,
        // confirmButtonColor: "#274c77",
        // cancelButtonColor: "#d33",
        // confirmButtonText: "Yes, delete it!"
    }).then((result) => {
        return result.isConfirmed
    });
}
export const errorPopup = (message) => {
    Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 3000,
        toast: true
    });
}
export const getCodeFromMaster = (name, master, fieldName, fieldCode) => {
    const foundItem = master?.find(item => {
        if (item.OTNAME) {
            const otnameArray = item?.OTNAME?.split(',');
            return otnameArray.some(otname => otname.trim()?.toUpperCase() === name?.toUpperCase());
        }
        else {
            return item[fieldName]?.toUpperCase() === name?.toUpperCase();
        }
    });
    return foundItem ? foundItem[fieldCode] : null;
};
export const getEXTNAMEfromColumnMaster = (fieldName, Master, ExtName) => {
    let foundItem = Master?.filter(x => x.CNAME === fieldName).map(i => i.EXTNAME).join(',');
    return foundItem;
}
export const confirmPopup = (testingTrue, testingFalse) => {
    return Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#274c77",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
    }).then((result) => {
        return result.isConfirmed
    });
}
export const confirmPopupwithfunction = (testingTrue, testingFalse) => {
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
    }).then((result) => {
        if (result.isConfirmed) {
            if (testingTrue) {
                testingTrue()
            }
        } else {
            if (testingFalse) {
                testingFalse()
            }
        }
    });
}


export const GridActionButton = {
    AddButton: {
        kind: "button-cell",
        backgroundColor: 'transparent',
        color: "accentColor",
        // borderColor: "#6572ffa0",
        borderRadius: 9,
        title: "Add New",
    },
    EditButton: {
        kind: "button-cell",
        backgroundColor: 'transparent',
        color: "accentColor",
        // borderColor: "#6572ffa0",
        borderRadius: 9,
        title: "Edit",
    },
    DeleteButton: {
        kind: "button-cell",
        backgroundColor: 'transparent',
        color: "accentColor",
        // borderColor: "#6572ffa0",
        borderRadius: 9,
        title: "Delete",
    },
    LinkButton: {
        kind: "button-cell",
        backgroundColor: "transparent",  //2nd is for hover Event
        color: "accentColor",
        // borderColor: "#6572ffa0",
        borderRadius: 0,
        title: "Link",
    },
    DemoButton: {
        kind: "button-cell",
        backgroundColor: ["transparent", "#6572ffee"],  //2nd is for hover Event
        color: ["accentColor", "accentFg"],
        borderColor: "#6572ffa0",
        borderRadius: 9,
        contentAlign: "left",
        title: "View Details",

    },
    GetDataButton: {
        kind: "button-cell",
        backgroundColor: ["transparent", "green"],
        color: ["green", "accentFg"],
        borderColor: "green",
        borderRadius: 7,
        contentAlign: "Center",
        title: "GetData",

    }
}

// export const SearchText = (obj, SearchColName, value, RetColumnName) => {
//     if (obj && Array.isArray(obj) && obj.length > 0) {
//         const searchValues = value.toString().split(',').map(item => item.trim().toUpperCase());
//         const matchingIds = [];
//         for (let i = 0; i < obj.length; i++) {
//             if (obj[i][SearchColName]) { 
//                 const columnValues = obj[i][SearchColName].trim().toUpperCase().split(',');
//                 for (const columnValue of columnValues) {
//                     if (searchValues.includes(columnValue.trim())) { 
//                         if (obj[i][RetColumnName]) {
//                             matchingIds.push(obj[i][RetColumnName]);
//                         } else {
//                             return null;
//                         }
//                     }
//                 }
//             }
//         }
//         return matchingIds
//     }
//     return null;
// };

export const SearchText = (obj, SearchColName, value, RetColumnName) => {
    if (obj && Array.isArray(obj) && obj.length > 0) {

        const searchValues = value.toString().split(',')?.map(item => item.trim().toUpperCase());
        const matchingIds = [];
        const matchedKeys = new Set();
        const trimLastComma = (str) => str.endsWith(",") ? str.slice(0, -1) : str;
        for (let i = 0; i < obj.length; i++) {
            if (trimLastComma(obj[i][SearchColName])) {
                const columnValues = trimLastComma(obj[i][SearchColName]).trim().toUpperCase().split(',');
                for (const columnValue of columnValues) {
                    if (searchValues.includes(columnValue.trim())) {
                        const key = columnValue.trim();
                        const valueToAdd = obj[i][RetColumnName] ? obj[i][RetColumnName] : null;
                        matchedKeys.add(key); // Mark the key as matched
                        const existingItemIndex = matchingIds.findIndex(item => item.key === key);
                        if (existingItemIndex !== -1) {
                            matchingIds[existingItemIndex].value = valueToAdd;
                        } else {
                            matchingIds.push({ key, value: valueToAdd });
                        }
                    }
                }
            }
        }
        // Add unmatched keys with null value
        for (const key of searchValues) {
            if (!matchedKeys.has(key)) {
                matchingIds.push({ key, value: null });
            }
        }
        return matchingIds;
    }
    return null;
};
export function ObjGetDataFromMastersKey(state, key) {

    const data = {
        'C_CODE': state.ColMast.DynDisp,
        'Q_CODE': state.ClarityMast.DynDisp,
        'CT_CODE': state.CutMast.DynDisp,
        'PO_CODE': state.CutMast.DynDisp,
        'SY_CODE': state.CutMast.DynDisp,
        'FL_CODE': state.FlorMast.DynDisp,
        'S_CODE': state.ShpMast.DynDisp,
        'GIRDLE_CODE': state.GirdleMast.DynDisp,
        'BGM_CODE': state.BGMMast.DynDisp,
        'EYE_CODE': state.EyeCleanMast.DynDisp,
        'GREEN_CODE': state.GreenMast.DynDisp,
        'MILKY_CODE': state.MilkyMast.DynDisp,
        'NATTS_CODE': state.NattsMast.DynDisp,
        'SR_CODE': state.ServiceMast.DynDisp,
        'SH_CODE': state.ShadeMast.DynDisp,
        'TERM_CODE': state.TermMast.DynDisp,
        'IN_CODE': state.WhiteIncMast.DynDisp,
        'BROWN_CODE': state.BrownMast.DynDisp,
        'COU_CODE': state.CountryMast.DynDisp,
        'LOC_CODE': state.LocMast.DynDisp,
        'FLOCOL': state.FloColMast.DynDisp,
        'CUSZ_CODE': state.CuletSizeMast.DynDisp,
        'CUCON_CODE': state.CuletConMast.DynDisp,
        'STKP_CODE': state.AccMast.DynDisp?.filter(item => item.AC_TYPE === 'STKPARTY'),
        'HRT_CODE': state.HeartArrowMast.DynDisp,
        'L_CODE': state.LotMast.LotMast,
    };

    return key ? data[key] : data;

}

export function GetNameFromKeyFromMaster(key) {

    const data = {
        'C_CODE': 'C_NAME',
        'Q_CODE': 'Q_NAME',
        'CT_CODE': 'CT_NAME',
        'PO_CODE': 'PO_NAME',
        'SY_CODE': 'SY_NAME',
        'FL_CODE': 'FL_NAME',
        'S_CODE': 'S_NAME',
        'GIRDLE_CODE': 'GIRDLE_NAME',
        'BGM_CODE': 'BGM_NAME',
        'EYE_CODE': 'EYE_NAME',
        'GREEN_CODE': 'GREEN_NAME',
        'MILKY_CODE': 'MILKY_NAME',
        'NATTS_CODE': 'NATTS_NAME',
        'SR_CODE': 'SR_NAME',
        'SH_CODE': 'SH_NAME',
        'TERM_CODE': 'TERM_NAME',
        'IN_CODE': 'IN_NAME',
        'BROWN_CODE': 'BROWN_NAME',
        'COU_CODE': 'COU_NAME',
        'LOC_CODE': 'LOC_NAME',
        'CUSZ_CODE': 'CUSZ_NAME',
        'CUCON_CODE': 'CUCON_NAME',
        'STKP_CODE': 'STKP_NAME',
        'HRT_CODE': 'HRT_NAME',
        'L_CODE': 'L_NAME',
    };

    return key ? data[key] : data;

}

export function FileDownloader(file, filename) {
    // Create a temporary anchor element
    const anchor = document.createElement('a');
    anchor.href = file;
    anchor.download = filename;

    // Programmatically click the anchor element to trigger the download
    anchor.click();
}

export function convertKeysToUpperCase(arr) {

    if (!Array.isArray(arr)) {
        throw new Error("Input must be an array of objects");
    }

    const convertKeys = obj => Object.entries(obj).reduce((acc, [key, value]) => {
        acc[key.toUpperCase()] = (typeof value === 'object' && value !== null && !Array.isArray(value))
            ? convertKeys(value)
            : value;
        return acc;
    }, {});

    return arr?.map(convertKeys);
}

export function ColumnAggregator({ data, columnName, operation }) {
    if (!data || data.length === 0 || !columnName) {
        return <div>0</div>;
    }

    const computeValue = () => {
        if (operation === 'SUM') {
            return data.reduce((acc, item) => acc + (item[columnName] || 0), 0);
        } else if (operation === 'COUNT') {
            return data.length;
        }
        return 0;
    };
    const result = computeValue();
    const formattedResult = result.toFixed(2);

    return (
        <div>
            {formattedResult}
        </div>
    );
}


export const ValidateDuplicateGrid = (OldRecord, newRecord) => {
    // Validate OldRecord and newRecord
    if (!Array.isArray(OldRecord)) {
        console.error("OldRecord is not an array or undefined:", OldRecord);
        OldRecord = []; // Default to an empty array
    }

    if (!Array.isArray(newRecord)) {
        console.error("newRecord is not an array or undefined:", newRecord);
        alert("Invalid data: newRecord is not defined or is not an array.");
        return OldRecord; // Return the original data if newRecord is invalid
    }

    let gridData = JSON.parse(JSON.stringify(OldRecord));
    let alreadyExistPkt = [];
    newRecord.forEach((x) => {
        if (!gridData.find(a => a.PKTID == x.PKTID)) {
            gridData.push(x)
        } else {
            alreadyExistPkt.push(x.PKTID)
        }
    })


    if (alreadyExistPkt?.length > 0) {
        alert(`Already exist ${alreadyExistPkt.join(', ')}`)
    }

    return gridData
}

export const ValidateDuplicateDataMix = (OldRecord, newRecord, ColumnName) => {
    if (!Array.isArray(OldRecord)) {
        console.error("OldRecord is not an array or undefined:", OldRecord);
        OldRecord = [];
    }

    if (!Array.isArray(newRecord)) {
        console.error("newRecord is not an array or undefined:", newRecord);
        alert("Invalid data: newRecord is not defined or is not an array.");
        return OldRecord;
    }
    let gridData = JSON.parse(JSON.stringify(OldRecord));
    let alreadyExistPkt = [];
    newRecord.forEach((x) => {
        if (!gridData.find(a => a[ColumnName] == x[ColumnName])) {
            gridData.push(x)
        } else {
            alreadyExistPkt.push(x[ColumnName])
        }
    })

    if (alreadyExistPkt?.length > 0) {
        alert(`Already exist ${alreadyExistPkt.join(', ')}`)
    }
    return gridData
}

export const fetchAndSetORate = async (row, ColMast, QuaMast, ShpMast) => {
    try {


        const ObjJson = {
            jsonObj1: [{
                S_CODE: ShpMast?.filter(Shp => Shp.S_NAME == row.S_NAME)[0]?.S_CODE,
                C_CODE: ColMast?.filter(col => col.C_NAME.includes(row.C_NAME))[0]?.C_CODE,
                Q_CODE: QuaMast?.filter(qua => qua.Q_NAME == row.Q_NAME)[0]?.Q_CODE,
                CARAT: row.I_CARAT
            }],
            SPName: "API_RapOrateFind"
        };

        const response = await DynamicFetchNew(ObjJson);
        if (response) {
            return response[0].ORate;
        }
    } catch (error) {
        console.error("Error fetching ORate:", error);
    }
};

export const fetchAndSetDisc = async (row, ColMast, QuaMast, CutMast, FLorMast, ShpMast) => {
    try {

        const ObjJson = {
            jsonObj1: [{
                CARAT: row.I_CARAT,
                S_CODE: ShpMast?.filter(Shp => Shp.S_NAME == row.S_NAME)[0]?.S_CODE,
                C_CODE: ColMast?.filter(col => col.C_NAME.includes(row.C_NAME))[0]?.C_CODE || 0,
                Q_CODE: QuaMast?.filter(qua => qua.Q_NAME == row.Q_NAME)[0]?.Q_CODE || 0,
                CT_CODE: CutMast?.filter(qua => qua.CT_NAME == row.CT_NAME)[0]?.CT_CODE || 0,
                FL_CODE: FLorMast?.filter(qua => qua.FL_NAME == row.FL_NAME)[0]?.FL_CODE || 0,
                RTYPE: row.DIAMONDTYPE,
            }],
            SPName: "API_RapDiscFind"
        };

        const response = await DynamicFetchNew(ObjJson);
        if (response) {
            return response[0].Disc;
        }
    } catch (error) {
        console.error("Error fetching ORate:", error);
    }
};

export const fetchAndSetRateFromDisc = async (row, ColMast, QuaMast, CutMast, FLorMast, ShpMast) => {
    try {

        const ObjJson = {
            jsonObj1: [{
                CARAT: row.I_CARAT,
                S_CODE: ShpMast?.filter(Shp => Shp.S_NAME == row.S_NAME)[0]?.S_CODE,
                C_CODE: ColMast?.filter(col => col.C_NAME.includes(row.C_NAME))[0]?.C_CODE || 0,
                Q_CODE: QuaMast?.filter(qua => qua.Q_NAME == row.Q_NAME)[0]?.Q_CODE || 0,
                CT_CODE: CutMast?.filter(qua => qua.CT_NAME == row.CT_NAME)[0]?.CT_CODE || 0,
                FL_CODE: FLorMast?.filter(qua => qua.FL_NAME == row.FL_NAME)[0]?.FL_CODE || 0,
                RTYPE: row.DIAMONDTYPE,
            }],
            SPName: "API_RapFromDiscFind"
        };

        const response = await DynamicFetchNew(ObjJson);
        if (response) {
            return response[0].Disc;
        }
    } catch (error) {
        console.error("Error fetching ORate:", error);
    }
};

export const fetchMixRate = async (row) => {
    try {


        const ObjJson = {
            jsonObj1: [{
                S_CODE: row.S_CODE,
                C_CODE: row.C_CODE,
                Q_CODE: row.Q_CODE,
                CT_CODE: row.CT_CODE,
                CH_CODE: row.CH_CODE,
                ID_CODE: row.ID_CODE,
            }],
            SPName: "mAPI_MixRateFind"
        };

        const response = await DynamicFetchNew(ObjJson);
        if (response) {
            return response[0].ORate;
        }
    } catch (error) {
        console.error("Error fetching ORate:", error);
    }
};

export const getChangedKeysFromObjs = (selectedRow, oldData) => {

    try {
        const oldRow = oldData.find(row => row.PKTID === selectedRow[0].PKTID);
        const changesObject = {
            PKTID: selectedRow[0].PKTID
        };

        if (oldRow) {
            Object.keys(selectedRow[0]).forEach(key => {
                if (selectedRow[0][key] !== oldRow[key]) {
                    changesObject[`OLD_${key}`] = oldRow[key];
                    changesObject[key] = selectedRow[0][key];
                }
            });

        }
        return Object.keys(changesObject).length ? changesObject : [];
    } catch (error) {
        console.error("Error fetching Keys:", error);
    }

};



// export const FindRowFeildValues = (currentRow, oldData, state) => {

//     let ShpMast = state.ShpMast.DynDisp;
//     let ColMast = state.ColMast.DynDisp?.filter(item => item.WEB_GROUP === 'WHITE COLOR' || item.COL_GROUP === "WHITE COLOR");
//     let QuaMast = state.ClarityMast.DynDisp;
//     let CutMast = state.CutMast.DynDisp;
//     let FLorMast = state.FlorMast.DynDisp;
//     let HRTMast = state.HeartArrowMast.DynDisp;
//     let GirdleMast = state.GirdleMast.DynDisp;
//     let BGMMast = state.BGMMast.DynDisp;
//     let NattsMast = state.NattsMast.DynDisp;
//     let MilkyMast = state.MilkyMast.DynDisp;
//     let EyeCleanMast = state.EyeCleanMast.DynDisp;
//     let BrownMast = state.BrownMast.DynDisp;
//     let GreenMast = state.GreenMast.DynDisp;
//     let WhiteIncMast = state.WhiteIncMast.DynDisp;
//     let BlackIncMast = state.BlackIncMast.DynDisp;
//     let OpenIncMast = state.OpenIncMast.DynDisp;
//     let CountryMast = state.CountryMast.DynDisp;
//     let LocationMast = state.LocMast.DynDisp;

//     const oldRow = oldData?.find(x => x.ROWNO === currentRow.ROWNO);
//     if (oldRow) {
//         if (currentRow.I_CARAT !== oldRow.I_CARAT) {
//             const rowI_CARAT = currentRow.I_CARAT;
//             currentRow.I_CARAT = rowI_CARAT;
//         }
//         if (currentRow.S_NAME !== oldRow.S_NAME) {
//             const rowS_NAME = currentRow.S_NAME;
//             const S_CODE = getCodeFromMaster(currentRow.S_NAME, ShpMast, "S_NAME", "S_CODE");
//             if (S_CODE) {
//                 currentRow.S_CODE = S_CODE;
//             } else {
//                 currentRow.S_CODE = '';
//             }
//             currentRow.S_NAME = rowS_NAME;
//         }
//         if (currentRow.C_NAME !== oldRow.C_NAME) {
//             const rowC_NAME = currentRow.C_NAME;
//             const C_CODE = getCodeFromMaster(currentRow.C_NAME, ColMast, "C_NAME", "C_CODE");
//             if (C_CODE) {
//                 currentRow.C_CODE = C_CODE;
//             } else {
//                 currentRow.C_CODE = 0;
//             }
//             currentRow.C_NAME = rowC_NAME;
//         }
//         if (currentRow.Q_NAME !== oldRow.Q_NAME) {
//             const rowQ_NAME = currentRow.Q_NAME;
//             const Q_CODE = getCodeFromMaster(currentRow.Q_NAME, QuaMast, "Q_NAME", "Q_CODE");
//             if (Q_CODE) {
//                 currentRow.Q_CODE = Q_CODE;
//             } else {
//                 currentRow.Q_CODE = 0;
//             }
//             currentRow.Q_NAME = rowQ_NAME;
//         }
//         if (currentRow.CT_NAME !== oldRow.CT_NAME) {
//             const rowCT_NAME = currentRow.CT_NAME;
//             const CT_CODE = getCodeFromMaster(currentRow.CT_NAME, CutMast, "CT_NAME", "CT_CODE");
//             if (CT_CODE) {
//                 currentRow.CT_CODE = CT_CODE;
//             } else {
//                 currentRow.CT_CODE = 0;
//             }
//             currentRow.CT_NAME = rowCT_NAME;
//         }
//         if (currentRow.PO_NAME !== oldRow.PO_NAME) {
//             const rowPO_NAME = currentRow.PO_NAME;
//             const PO_CODE = getCodeFromMaster(currentRow.PO_NAME, CutMast, "CT_NAME", "CT_CODE");
//             if (PO_CODE) {
//                 currentRow.PO_CODE = PO_CODE;
//             } else {
//                 currentRow.PO_CODE = 0;
//             }
//             currentRow.PO_NAME = rowPO_NAME;
//         }
//         if (currentRow.SY_NAME !== oldRow.SY_NAME) {
//             const rowSY_NAME = currentRow.SY_NAME;
//             const SY_CODE = getCodeFromMaster(currentRow.SY_NAME, CutMast, "CT_NAME", "CT_CODE");
//             if (SY_CODE) {
//                 currentRow.SY_CODE = SY_CODE;
//             } else {
//                 currentRow.SY_CODE = 0;
//             }
//             currentRow.SY_NAME = rowSY_NAME;
//         }
//         if (currentRow.FL_NAME !== oldRow.FL_NAME) {
//             const rowFL_NAME = currentRow.FL_NAME;
//             const FL_CODE = getCodeFromMaster(currentRow.FL_NAME, FLorMast, "FL_NAME", "FL_CODE");
//             if (FL_CODE) {
//                 currentRow.FL_CODE = FL_CODE;
//             } else {
//                 currentRow.FL_CODE = 0;
//             }
//             currentRow.FL_NAME = rowFL_NAME;
//         }
//         if (currentRow.GIRDLE_NAME !== oldRow.GIRDLE_NAME) {
//             const rowGIRDLE_NAME = currentRow.GIRDLE_NAME;
//             const GIRDLE_CODE = getCodeFromMaster(currentRow.GIRDLE_NAME, GirdleMast, "GIRDLE_NAME", "GIRDLE_CODE");
//             if (GIRDLE_CODE) {
//                 currentRow.GIRDLE_CODE = GIRDLE_CODE;
//             } else {
//                 currentRow.GIRDLE_CODE = 0;
//             }
//             currentRow.GIRDLE_NAME = rowGIRDLE_NAME;
//         }
//         if (currentRow.HRT_NAME !== oldRow.HRT_NAME) {
//             const rowHRT_NAME = currentRow.HRT_NAME;
//             const HRT_CODE = getCodeFromMaster(currentRow.HRT_NAME, HRTMast, "HRT_NAME", "HRT_CODE");
//             if (HRT_CODE) {
//                 currentRow.HRT_CODE = HRT_CODE;
//             } else {
//                 currentRow.HRT_CODE = 0;
//             }
//             currentRow.HRT_NAME = rowHRT_NAME;
//         }
//         if (currentRow.BGM_NAME !== oldRow.BGM_NAME) {
//             const rowBGM_NAME = currentRow.BGM_NAME;
//             const BGM_CODE = getCodeFromMaster(currentRow.BGM_NAME, BGMMast, "BGM_NAME", "BGM_CODE");
//             if (BGM_CODE) {
//                 currentRow.BGM_CODE = BGM_CODE;
//             } else {
//                 currentRow.BGM_CODE = 0;
//             }
//             currentRow.BGM_NAME = rowBGM_NAME;
//         }
//         if (currentRow.NATTS_NAME !== oldRow.NATTS_NAME) {
//             const rowNATTS_NAME = currentRow.NATTS_NAME;
//             const NATTS_CODE = getCodeFromMaster(currentRow.NATTS_NAME, NattsMast, "NATTS_NAME", "NATTS_CODE");
//             if (NATTS_CODE) {
//                 currentRow.NATTS_CODE = NATTS_CODE;
//             } else {
//                 currentRow.NATTS_CODE = 0;
//             }
//             currentRow.NATTS_NAME = rowNATTS_NAME;
//         }
//         if (currentRow.MILKY_NAME !== oldRow.MILKY_NAME) {
//             const rowMILKY_NAME = currentRow.MILKY_NAME;
//             const MILKY_CODE = getCodeFromMaster(currentRow.MILKY_NAME, MilkyMast, "MILKY_NAME", "MILKY_CODE");
//             if (MILKY_CODE) {
//                 currentRow.MILKY_CODE = MILKY_CODE;
//             } else {
//                 currentRow.MILKY_CODE = 0;
//             }
//             currentRow.MILKY_NAME = rowMILKY_NAME;
//         }
//         if (currentRow.EYE_NAME !== oldRow.EYE_NAME) {
//             const rowEYE_NAME = currentRow.EYE_NAME;
//             const EYE_CODE = getCodeFromMaster(currentRow.EYE_NAME, EyeCleanMast, "EYE_NAME", "EYE_CODE");
//             if (EYE_CODE) {
//                 currentRow.EYE_CODE = EYE_CODE;
//             } else {
//                 currentRow.EYE_CODE = 0;
//             }
//             currentRow.EYE_NAME = rowEYE_NAME;
//         }
//         if (currentRow.BROWN_NAME !== oldRow.BROWN_NAME) {
//             const rowBROWN_NAME = currentRow.BROWN_NAME;
//             const BROWN_CODE = getCodeFromMaster(currentRow.BROWN_NAME, BrownMast, "BROWN_NAME", "BROWN_CODE");
//             if (BROWN_CODE) {
//                 currentRow.BROWN_CODE = BROWN_CODE;
//             } else {
//                 currentRow.BROWN_CODE = 0;
//             }
//             currentRow.BROWN_NAME = rowBROWN_NAME;
//         }
//         if (currentRow.GREEN_NAME !== oldRow.GREEN_NAME) {
//             const rowGREEN_NAME = currentRow.GREEN_NAME;
//             const GREEN_CODE = getCodeFromMaster(currentRow.GREEN_NAME, GreenMast, "GREEN_NAME", "GREEN_CODE");
//             if (GREEN_CODE) {
//                 currentRow.GREEN_CODE = GREEN_CODE;
//             } else {
//                 currentRow.GREEN_CODE = 0;
//             }
//             currentRow.GREEN_NAME = rowGREEN_NAME;
//         }
//         if (currentRow.NATTS_NAME !== oldRow.NATTS_NAME) {
//             const rowNATTS_NAME = currentRow.NATTS_NAME;
//             const NATTS_CODE = getCodeFromMaster(currentRow.NATTS_NAME, NattsMast, "NATTS_NAME", "NATTS_CODE");
//             if (NATTS_CODE) {
//                 currentRow.NATTS_CODE = NATTS_CODE;
//             } else {
//                 currentRow.NATTS_CODE = 0;
//             }
//             currentRow.NATTS_NAME = rowNATTS_NAME;
//         }
//         if (currentRow.WTINC_NAME !== oldRow.WTINC_NAME) {
//             const rowWTINC_NAME = currentRow.WTINC_NAME;
//             const WTINC_CODE = getCodeFromMaster(currentRow.WTINC_NAME, WhiteIncMast, "IN_NAME", "IN_CODE");
//             if (WTINC_CODE) {
//                 currentRow.WTINC_CODE = WTINC_CODE;
//             } else {
//                 currentRow.WTINC_CODE = 0;
//             }
//             currentRow.WTINC_NAME = rowWTINC_NAME;
//         }
//         if (currentRow.WSINC_NAME !== oldRow.WSINC_NAME) {
//             const rowWSINC_NAME = currentRow.WSINC_NAME;
//             const WSINC_CODE = getCodeFromMaster(currentRow.WSINC_NAME, WhiteIncMast, "IN_NAME", "IN_CODE");
//             if (WSINC_CODE) {
//                 currentRow.WSINC_CODE = WSINC_CODE;
//             }
//             else {
//                 currentRow.WSINC_CODE = 0;
//             }
//             currentRow.WSINC_NAME = rowWSINC_NAME;
//         }
//         if (currentRow.BTINC_NAME !== oldRow.BTINC_NAME) {
//             const rowBTINC_NAME = currentRow.BTINC_NAME;
//             const BTINC_CODE = getCodeFromMaster(currentRow.BTINC_NAME, BlackIncMast, "IN_NAME", "IN_CODE");
//             if (BTINC_CODE) {
//                 currentRow.BTINC_CODE = BTINC_CODE;
//             } else {
//                 currentRow.BTINC_CODE = 0;
//             }
//             currentRow.BTINC_NAME = rowBTINC_NAME;
//         }
//         if (currentRow.BSINC_NAME !== oldRow.BSINC_NAME) {
//             const rowBSINC_NAME = currentRow.BSINC_NAME;
//             const BSINC_CODE = getCodeFromMaster(currentRow.BSINC_NAME, BlackIncMast, "IN_NAME", "IN_CODE");
//             if (BSINC_CODE) {
//                 currentRow.BSINC_CODE = BSINC_CODE;
//             } else {
//                 currentRow.BSINC_CODE = 0;
//             }
//             currentRow.BSINC_NAME = rowBSINC_NAME;
//         }
//         if (currentRow.OTINC_NAME !== oldRow.OTINC_NAME) {
//             const rowOTINC_NAME = currentRow.OTINC_NAME;
//             const OTINC_CODE = getCodeFromMaster(currentRow.OTINC_NAME, OpenIncMast, "IN_NAME", "IN_CODE");
//             if (OTINC_CODE) {
//                 currentRow.OTINC_CODE = OTINC_CODE;
//             } else {
//                 currentRow.OTINC_CODE = 0;
//             }
//             currentRow.OTINC_NAME = rowOTINC_NAME;
//         }
//         if (currentRow.OSINC_NAME !== oldRow.OSINC_NAME) {
//             const rowOSINC_NAME = currentRow.OSINC_NAME;
//             const OSINC_CODE = getCodeFromMaster(currentRow.OSINC_NAME, OpenIncMast, "IN_NAME", "IN_CODE");
//             if (OSINC_CODE) {
//                 currentRow.OSINC_CODE = OSINC_CODE;
//             } else {
//                 currentRow.OSINC_CODE = 0;
//             }
//             currentRow.OSINC_NAME = rowOSINC_NAME;
//         }
//         if (currentRow.OPINC_NAME !== oldRow.OPINC_NAME) {
//             const rowOPINC_NAME = currentRow.OPINC_NAME;
//             const OPINC_CODE = getCodeFromMaster(currentRow.OPINC_NAME, OpenIncMast, "IN_NAME", "IN_CODE");
//             if (OPINC_CODE) {
//                 currentRow.OPINC_CODE = OPINC_CODE;
//             } else {
//                 currentRow.OPINC_CODE = 0;
//             }
//             currentRow.OPINC_NAME = rowOPINC_NAME;
//         }
//         if (currentRow.COU_NAME !== oldRow.COU_NAME) {
//             const rowCOU_NAME = currentRow.COU_NAME;
//             const COU_CODE = getCodeFromMaster(currentRow.COU_NAME, CountryMast, "COU_NAME", "COU_CODE");
//             if (COU_CODE) {
//                 currentRow.COU_CODE = COU_CODE;
//             } else {
//                 currentRow.COU_CODE = 0;
//             }
//             currentRow.COU_NAME = rowCOU_NAME;
//         }
//         if (currentRow.LOC_NAME !== oldRow.LOC_NAME) {
//             const rowLOC_NAME = currentRow.LOC_NAME;
//             const LOC_CODE = getCodeFromMaster(currentRow.LOC_NAME, LocationMast, "LOC_NAME", "LOC_CODE");
//             if (LOC_CODE) {
//                 currentRow.LOC_CODE = LOC_CODE;
//             } else {
//                 currentRow.LOC_CODE = 0;
//             }
//             currentRow.LOC_NAME = rowLOC_NAME;
//         }
//         return currentRow;
//     }

// };


export const FindRowFeildValues = (currentRow, oldData, state, pagename) => {
    let oldRow ;
    if (pagename == 'LABREC') {
        oldRow = oldData?.find(x => x.PKTID === currentRow.PKTID);
    }
    else{
        oldRow = oldData?.find(x => x.ROWNO === currentRow.ROWNO);
    }
    
    if (!oldRow) return currentRow;
    const masters = {
        S_NAME: { master: state.ShpMast.DynDisp, nameField: "S_NAME", codeField: "S_CODE", FindKey: "S_CODE" },
        C_NAME: { master: state.ColMast.DynDisp, nameField: "C_NAME", codeField: "C_CODE", FindKey: "C_CODE" },
        Q_NAME: { master: state.ClarityMast.DynDisp, nameField: "Q_NAME", codeField: "Q_CODE", FindKey: "Q_CODE" },
        CT_NAME: { master: state.CutMast.DynDisp, nameField: "CT_NAME", codeField: "CT_CODE", FindKey: "CT_CODE" },
        PO_NAME: { master: state.CutMast.DynDisp, nameField: "CT_NAME", codeField: "PO_CODE", FindKey: "CT_CODE" },
        SY_NAME: { master: state.CutMast.DynDisp, nameField: "CT_NAME", codeField: "SY_CODE", FindKey: "CT_CODE" },
        FL_NAME: { master: state.FlorMast.DynDisp, nameField: "FL_NAME", codeField: "FL_CODE", FindKey: "FL_CODE" },
        GIRDLE_NAME: { master: state.GirdleMast.DynDisp, nameField: "GIRDLE_NAME", codeField: "GIRDLE_CODE", FindKey: "GIRDLE_CODE" },
        HRT_NAME: { master: state.HeartArrowMast.DynDisp, nameField: "HRT_NAME", codeField: "HRT_CODE", FindKey: "HRT_CODE" },
        BGM_NAME: { master: state.BGMMast.DynDisp, nameField: "BGM_NAME", codeField: "BGM_CODE", FindKey: "BGM_CODE" },
        NATTS_NAME: { master: state.NattsMast.DynDisp, nameField: "NATTS_NAME", codeField: "NATTS_CODE", FindKey: "NATTS_CODE" },
        MILKY_NAME: { master: state.MilkyMast.DynDisp, nameField: "MILKY_NAME", codeField: "MILKY_CODE", FindKey: "MILKY_CODE" },
        EYE_NAME: { master: state.EyeCleanMast.DynDisp, nameField: "EYE_NAME", codeField: "EYE_CODE", FindKey: "EYE_CODE" },
        BROWN_NAME: { master: state.BrownMast.DynDisp, nameField: "BROWN_NAME", codeField: "BROWN_CODE", FindKey: "BROWN_CODE" },
        GREEN_NAME: { master: state.GreenMast.DynDisp, nameField: "GREEN_NAME", codeField: "GREEN_CODE", FindKey: "GREEN_CODE" },
        WTINC_NAME: { master: state.WhiteIncMast.DynDisp, nameField: "WTINC_NAME", codeField: "WTINC_CODE", FindKey: "IN_CODE" },
        WSINC_NAME: { master: state.WhiteIncMast.DynDisp, nameField: "WSINC_NAME", codeField: "WSINC_CODE", FindKey: "IN_CODE" },
        BTINC_NAME: { master: state.BlackIncMast.DynDisp, nameField: "BTINC_NAME", codeField: "BTINC_CODE", FindKey: "IN_CODE" },
        BSINC_NAME: { master: state.BlackIncMast.DynDisp, nameField: "BSINC_NAME", codeField: "BSINC_CODE", FindKey: "IN_CODE" },
        OTINC_NAME: { master: state.OpenIncMast.DynDisp, nameField: "OTINC_NAME", codeField: "OTINC_CODE", FindKey: "IN_CODE" },
        OSINC_NAME: { master: state.OpenIncMast.DynDisp, nameField: "OSINC_NAME", codeField: "OSINC_CODE", FindKey: "IN_CODE" },
        OPINC_NAME: { master: state.OpenIncMast.DynDisp, nameField: "OPINC_NAME", codeField: "OPINC_CODE", FindKey: "IN_CODE" },
        COU_NAME: { master: state.CountryMast.DynDisp, nameField: "COU_NAME", codeField: "COU_CODE", FindKey: "COU_CODE" },
        LOC_NAME: { master: state.LocMast.DynDisp, nameField: "LOC_NAME", codeField: "LOC_CODE", FindKey: "LOC_CODE" },
        ID_NAME: { master: state.MixIdentityMast.DynDisp, nameField: "ID_NAME", codeField: "ID_CODE", FindKey: "ID_CODE" },
        CH_NAME: { master: state.MixCharMast.DynDisp, nameField: "CH_NAME", codeField: "CH_CODE", FindKey: "CH_CODE" },
    };

    const updateField = (fieldName) => {
        if (currentRow[fieldName] !== oldRow[fieldName]) {
            const { master, nameField, codeField, FindKey } = masters[fieldName];
            const code = getCodeFromMaster(currentRow[fieldName], master, nameField, FindKey);
            currentRow[codeField] = code || 0; // Set the code field value
        }
    };

    Object.keys(masters).forEach(updateField);
    if (currentRow.I_CARAT !== oldRow.I_CARAT) {
        currentRow.I_CARAT = currentRow.I_CARAT;
    }
    return currentRow;
};



export default getList